import { AppStorage } from "@bbwt/utils/app-storage";
import { IEpisode } from "@project/models/episodes/episode";

export class EpisodeOfflineStorage {
    private static readonly cacheKey = "api/episode";

    static get(id: string): IEpisode {
        return this.correctDateTime(AppStorage.getOfflineEntity<IEpisode>(id, this.cacheKey));
    }

    static save(episode: IEpisode): IEpisode {
        return this.correctDateTime(AppStorage.setOfflineEntity<IEpisode>(this.cacheKey, episode));
    }

    static getAll(): IEpisode[] {
        return AppStorage.getOfflineEntities<IEpisode>(this.cacheKey).map(episode => this.correctDateTime(episode));
    }

    static remove(id: string): IEpisode {
        return this.correctDateTime(AppStorage.extractOfflineEntity<IEpisode>(id, this.cacheKey));
    }

    static update(episode: IEpisode): IEpisode {
        return this.correctDateTime(AppStorage.replaceOfflineEntity(episode, this.cacheKey));
    }

    static updatePatientId(oldPatientId: string, patientUserId: string): void {
        var updatedItems = this.getAll()
            .filter(e => e.patientUserId == oldPatientId)
            .map(episode => ({ ...episode, patientUserId }));
        updatedItems.forEach(e => this.update(e));
    }

    private static correctDateTime(episode: IEpisode): IEpisode {
        return episode?.createDateTime? { ...episode, createDateTime: new Date(episode.createDateTime) }: episode;
    }
}
